export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const FETCH_LOGGEDIN_EMPLOYEE = 'FETCH_LOGGEDIN_EMPLOYEE';
export const FETCH_USER_WITH_PERMISSIONS_DATA = 'FETCH_USER_WITH_PERMISSIONS_DATA';
export const LOAD_USER_PERMISSIONS = 'LOAD_USER_PERMISSIONS';
export const CHANGE_HEADER_TITLE = 'CHANGE_HEADER_TITLE';